import React from 'react'
import { Button, Item } from 'lib/ui'
import Link from 'lib/components/Link'

import DateDisplay from './DateDisplay'
import BasicDetails from './BasicDetails'
import CategoryIcon from './CategoryIcon'
import CategoryList from './CategoryList'

const RecallDates = ({ recall }) => {
  const pubStartSame = recall.date_published === recall.start_date
  return (
    <>
      <DateDisplay label="Posted" date={recall.date_published * 1000} />
      {!pubStartSame && (
        <>
          <span>-</span>
          <DateDisplay label="Starting" date={recall.start_date * 1000} />
        </>
      )}
    </>
  )
}

import ForwardedHeader from 'lib/components/ForwardedHeader'

const Recall = ({ data, itemMeta = null, interactive = true }) => {
  return (
    <Item>
      <Item.Image
        size="tiny"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CategoryIcon category={data.category[0]} size="huge" />
      </Item.Image>

      <Item.Content>
        {interactive && data.apiId ? (
          <Link href="/recall/[apiId]" as={`/recall/${data.apiId}`} passHref>
            <ForwardedHeader as="a">{data.parsed.title}</ForwardedHeader>
          </Link>
        ) : (
          <ForwardedHeader>{data.parsed.title}</ForwardedHeader>
        )}
        <Item.Meta>
          {itemMeta}
          <RecallDates recall={data} />
          <span>-</span>
          <span>
            <CategoryList categories={data.category} />
          </span>
        </Item.Meta>
        <Item.Description>
          <BasicDetails data={data.parsed.basic_details} />
        </Item.Description>
        <Item.Extra
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {interactive && data.apiId ? (
            <Link href="/recall/[apiId]" as={`/recall/${data.apiId}`} passHref>
              <Button as="a" compact basic size="small">
                More Information
              </Button>
            </Link>
          ) : (
            <Button
              as="span"
              compact
              basic
              size="small"
              style={{ cursor: 'default' }}
            >
              More Information
            </Button>
          )}
        </Item.Extra>
      </Item.Content>
    </Item>
  )
}

export default Recall
